import {mobileMatch, windowWidth} from "../common";


export class Header {
    constructor() {
        this.el = document.querySelector('header');
        this.el.classList.add('loaded');
        this._reformTopMenu = this._reformTopMenu.bind(this);

        $(document)
            .on('touchend', '.bars.mob', this._mobileBar)
            .on('click', Header._removeDotsMenuOnClick)
            .on('click', '.links-ct__dots-list', Header._preventDefault)
            .on('click', '.links-ct__dots', Header._toogleDotsMenu)
            .on('mouseover', '.links-ct a[href^="/contacts/"], .contacts_list', this._mouseover)
            .on('mouseleave', '.links-ct a[href^="/contacts/"], .contacts_list', this._mouseleave);

        this.linksInner = document.querySelector('.links-ct').innerHTML;
        this.prevWindowWidth = window.innerWidth;

        window.addEventListener('resize', this._reformTopMenu);

        this._reformTopMenu();
    }

    _mouseover() {
        $(this).parents('.links').find(".contacts_list").show();
    }

    _mouseleave() {
        $(this).parents('.links').find(".contacts_list").hide();
    }

    _mobileBar() {
        if  ($(this).hasClass('close-menu')) {
            $('header').removeClass('fix');
            $('.header_mob--menu').removeClass('show-it');
            $('.links .current').removeClass('bg_y');
            $('main section, footer').removeClass('hide');
            $(this).removeClass('close-menu');
        } else {
            $('header').addClass('fix');
            $('.header_mob--menu').addClass('show-it');
            $('.links .current').addClass('bg_y');
            $('main section, footer').addClass('hide');
            $(this).addClass('close-menu');
        }
    }

    _reformTopMenu() {
        let ct = document.querySelector('.links-ct');

        if (document.querySelector('.links-ct__dots') && this.prevWindowWidth < window.innerWidth) {
            ct.innerHTML = this.linksInner;
        }

        this.prevWindowWidth = window.innerWidth;

        let links = ct.querySelectorAll('a');

        if (!mobileMatch.matches) {
            let commonWidth = 0;
            let linksWidth = 0;
            let nodes = [];
            links.forEach((e) => {
                let elementWidth = Header._getElementWidth(e);

                nodes.unshift({'element': e, 'size': elementWidth });
                linksWidth += elementWidth;
            });

            let header = document.querySelector('header'),
                headerInnerWidth = Header._getElementWidthNoPadding(header);

            for (let i = 0; i < header.children.length; i++) {
                let e = header.children[i];
                let elementWidth = Header._getElementWidth(e);

                if (!$(e).hasClass('links') && e.offsetParent !== null && !$(e).hasClass('xmas--header_ct')) {
                    commonWidth +=elementWidth;
                }
            }

            if (headerInnerWidth - (commonWidth+linksWidth) <= 0) {
                let currentWidth = commonWidth+linksWidth + 72; // 72 - dots width;
                let dotsInnerHTML = [];
                let counter = 0;

                for (let i=0; i < nodes.length; i++) {
                    let e = nodes[i];

                    counter++;
                    currentWidth -= e.size;
                    dotsInnerHTML.unshift(e.element);

                    if (headerInnerWidth - currentWidth >= 0) break;
                }

                let tmp = nodes.slice(counter);
                let tmpDom = document.createElement('div');
                tmp.map(e => $(tmpDom).prepend(e.element));

                let dtsDom = document.createElement('div');
                dotsInnerHTML.map(e => dtsDom.appendChild(e));

                ct.innerHTML = `${tmpDom.innerHTML}<div class="links-ct__dots"><div class="links-ct__dots-list">${dtsDom.innerHTML}</div></div>`;
            }
        }
    }

    static _getElementWidth(e) {
        let style = window.getComputedStyle ? getComputedStyle(e, null) : e.currentStyle;
        // let left = (parseInt(style.marginLeft) || 0) < 50 ? style.marginLeft : style.marginRight; // костыл 3000

        return e.clientWidth + (parseInt(style.marginLeft) || 0) + (parseInt(style.marginRight) || 0);
    }

    static _getElementWidthNoPadding(e) {
        let style = window.getComputedStyle ? getComputedStyle(e, null) : e.currentStyle;

        return e.clientWidth - (parseInt(style.paddingLeft) || 0) - (parseInt(style.paddingRight) || 0);
    }

    static _toogleDotsMenu(e) {
        Header._preventDefault(e);
        $('.links-ct__dots').toggleClass('active');
    }

    static _removeDotsMenuOnClick() {
        $('.links-ct__dots').removeClass('active');
    }

    static _preventDefault(e) {
        e.stopPropagation();
    }
}

export class Form {
    constructor() {
        $(document).on('change blur keyup', '#cancelForm', this._cancelForm);
    }

    _cancelForm() {
        if ($(this).find('textarea').val() != "") {
            $(this).find('button').css({'background-color': 'rgba(66, 165, 245, 0.1)', 'color': '#0275CB'});
        } else {
            $(this).find('button').css({'background-color': 'rgba(0, 0, 0, 0.1)', 'color': '#fff'});
        }
    }
}